// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Login_wrap__RP7qC","button":"Login_button__juoVp","reg":"Login_reg__l74Du"};